:host {
  display: block;
}

.checkbox-group-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.group-label {
  font-weight: 500;
  margin-bottom: 0.25rem;

  .required {
    color: var(--nylas-error);
    margin-left: 0.25rem;
  }
}

.checkbox-list {
  display: flex;
  gap: 16px;

  &.vertical {
    flex-direction: column;
  }

  &.horizontal {
    flex-direction: row;
    align-items: center;
  }

  checkbox-component {
    width: max-content;
    &::part(checkbox-label-span) {
      width: inherit;
      margin-left: 24px;
    }
  }
}

.error {
  color: var(--nylas-error);
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
